import React from "react";
import { 
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
  CDBBadge } from "cdbreact";
import { Layout } from "../Layout";
import { TemplateNav } from "../TemplateNav";
import Sidebar from "../Sidebar";


export const SideBar = () => {


    return (
      <div className="d-flex w-100">
        <div style={{height:"100vh", overflow:"hidden initial"}}>
          <Sidebar/>
        </div>
        <Layout>
          <TemplateNav/>
      <div classname="r-w">
        <div className="blockcode text-center">
          <div className="header">Sidebar</div>
          <div className="example" style={{flexDirection:"column", minWidth:"350px"}}>
            <div
              className={`app`}
              style={{ display: "flex"}}
            >
              <CDBSidebar
                textColor="#fff"
                backgroundColor="#000"
              >
                <CDBSidebarHeader
                  prefix={
                    <i className="fa fa-bars" />
                  }
                >
                    Contrast Free
                </CDBSidebarHeader>

                <CDBSidebarContent>
                  <CDBSidebarMenu>
                    <CDBSidebarMenuItem
                      icon="th-large"
                    >
                      Dashboard
                    </CDBSidebarMenuItem>
                    <CDBSidebarMenuItem
                      icon="sticky-note"
                    >
                      Components
                    </CDBSidebarMenuItem>
                  </CDBSidebarMenu>
                  <CDBSidebarMenu>
                    <CDBSidebarMenuItem icon="th">Menu Item</CDBSidebarMenuItem>
                  </CDBSidebarMenu>
                </CDBSidebarContent>

                <CDBSidebarFooter style={{ textAlign: "center" }}>
                  <div
                    className="sidebar-btn-wrapper"
                    style={{
                      padding: "20px 5px"
                    }}
                  >
                    Sidebar Footer
                  </div>
                </CDBSidebarFooter>
              </CDBSidebar>
            </div>
          </div>
        </div>
      </div>
      </Layout>
    </div>
    );
};